import React, { useContext } from 'react';
import { Menu, MenuItem, CircularProgress, SvgIcon, Divider, ListSubheader } from '@material-ui/core';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import { ReactComponent as AddFormulaIcon } from '../../../assets/icons/add-formula.svg';
import { ReactComponent as ExportCsvIcon } from '../../../assets/icons/export-csv.svg';
import { DataSpaceViewContext } from '../context/DataSpaceViewContext';

export default function DataSpaceViewMenu({
	anchorEl,
	onClose,
	csvLoading,
	handleExportCSV,
	refreshDataSpace,
	openCalculatedColumnPanelOnClick,
	handleClickSeeDetails,
	dataTableRef,
	views,
	handleSwitchView,
	isEditingDisabled,
}) {
	const { selectedView } = useContext(DataSpaceViewContext);

	return (
		<Menu
			anchorEl={anchorEl}
			open={Boolean(anchorEl)}
			onClose={onClose}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
		>
			{!isEditingDisabled && (
				<MenuItem
					onClick={() => {
						onClose();
						refreshDataSpace();
					}}
				>
					<AutorenewOutlinedIcon style={{ marginRight: 8 }} />
					Refresh
				</MenuItem>
			)}

			{!isEditingDisabled && (
				<MenuItem
					onClick={() => {
						onClose();
						openCalculatedColumnPanelOnClick();
					}}
				>
					<SvgIcon style={{ width: '1.3rem', height: '1.3rem', marginRight: 8 }}>
						<AddFormulaIcon />
					</SvgIcon>
					Add Calculated Column
				</MenuItem>
			)}

			{!isEditingDisabled && (
				<MenuItem onClick={handleExportCSV} disabled={csvLoading}>
					{csvLoading ? (
						<CircularProgress size={20} style={{ marginRight: 8 }} />
					) : (
						<SvgIcon style={{ width: '1.3rem', height: '1.3rem', marginRight: 8 }}>
							<ExportCsvIcon />
						</SvgIcon>
					)}
					Export CSV
				</MenuItem>
			)}

			<MenuItem
				onClick={() => {
					onClose();
					handleClickSeeDetails();
				}}
			>
				<InfoOutlinedIcon style={{ marginRight: 8 }} />
				See Details
			</MenuItem>

			{!isEditingDisabled && (
				<MenuItem
					onClick={() => {
						onClose();
						dataTableRef.current.saveViewClickHandler();
					}}
				>
					<InfoOutlinedIcon style={{ marginRight: 8 }} />
					Save View
				</MenuItem>
			)}

			{!isEditingDisabled && (
				<MenuItem
					onClick={() => {
						onClose();
						dataTableRef.current.createViewClickHandler();
					}}
				>
					<InfoOutlinedIcon style={{ marginRight: 8 }} />
					Create View
				</MenuItem>
			)}

			{views && views.length > 0 && (
				<>
					<Divider />
					<ListSubheader>Select View</ListSubheader>
					{views
						.filter((view) => !isEditingDisabled || view.isShared)
						.map((view) => {
							const isSelected = selectedView && selectedView.id === view.id;
							return (
								<MenuItem
									key={view.id}
									onClick={() => {
										handleSwitchView(view.id);
									}}
									style={isSelected ? { backgroundColor: '#FF9800', color: 'white' } : {}}
								>
									<ViewModuleIcon style={{ marginRight: 8 }} />
									{view.name}
								</MenuItem>
							);
						})}
				</>
			)}
		</Menu>
	);
}
